import "./styles.scss";
import { ASLoginUrl } from "../../helpers/constants";

// Shown when account/token data could not be loaded. Gives the user a way
// forward (retry or sign in) instead of an indefinite spinner.
const LoadErrorPage = (): JSX.Element => {
  return (
    <div className="load-error" role="alert">
      <h1 className="load-error-title">We can&apos;t load your account right now</h1>
      <p className="load-error-message">
        Something went wrong while retrieving your account information. Please try
        again, or sign in to continue.
      </p>
      <div className="load-error-actions">
        <button
          type="button"
          className="load-error-retry"
          onClick={() => window.location.reload()}
        >
          Try again
        </button>
        <a className="load-error-signin" href={ASLoginUrl}>
          Sign in
        </a>
      </div>
    </div>
  );
};

export default LoadErrorPage;
